var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _g, _g2, _path8, _path9, _g3, _rect2, _g4, _ellipse2, _path10, _ellipse3, _path11, _ellipse4, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSfreeBotImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 325,
    viewBox: "0 0 287 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.99 43.2816C177.513 69.2739 202.311 28.8007 233.089 43.2816C294.354 72.1064 246.916 108.953 253.829 215.411C260.742 321.869 50.5924 317.029 79.6262 241.68C108.66 166.33 11.1884 220.941 0.819175 108.953C-9.55004 -3.03437 106.585 10.7913 145.99 43.2816Z",
    fill: "#EDFFF5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7426,
    ry: 1.57555,
    transform: "matrix(1 0 0 -1 138.245 172.365)",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.118 99.3966C103.083 78.2765 108.437 63.7723 111.493 59.1602L125.879 60.1144C124.404 66.953 121.073 81.6162 119.556 85.5604C118.038 89.5045 116.499 96.958 116.078 101.305L106.118 99.3966Z",
    fill: "#D5B98F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.287 67.9072C158.414 60.1462 156.232 53.0108 155.126 50.4132L165.401 45.324C172.863 55.6296 172.937 69.0205 172.041 74.4278C171.092 78.9868 169.29 89.0592 169.67 92.8761C170.049 96.693 170.566 100.086 170.776 101.305H159.868C159.341 100.192 158.604 97.7108 159.868 96.693C161.133 95.6751 161.133 90.5435 160.975 88.105C160.026 84.6061 158.161 75.6683 158.287 67.9072Z",
    fill: "#D5B98F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.595 34.5111C105.928 30.058 109.964 9.64826 112.441 0H171.881C172.355 1.2723 173.557 4.67569 174.568 8.1109C175.58 11.5461 171.617 19.0845 169.51 22.4242C170.774 23.4845 173.019 25.8594 171.881 26.8773C170.743 27.8951 169.826 35.0412 169.51 38.487V50.5738C169.51 49.8847 168.371 49.8741 163.818 55.3449C159.265 60.8158 154.755 56.6702 153.068 53.9136V48.5063L140.105 31.1713L129.671 50.5738C129.197 53.5425 127.521 60.1161 124.613 62.6606C121.704 65.2052 118.447 65.0992 117.182 64.7281L109.595 60.5932L110.701 52.6413C107.539 50.3512 108.646 39.6003 109.595 34.5111Z",
    fill: "#19253D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 133.91H128.883V101.625L140.739 81.9048L151.489 101.625V124.05",
    stroke: "black",
    strokeWidth: 4.93509
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.306 29.1032C120.406 31.5205 120.976 41.137 122.873 45.643C130.082 52.7676 135.677 49.248 137.574 46.5977H143.423C145.109 48.135 150.126 50.2873 156.703 46.5977C163.279 42.908 160.497 35.8359 158.283 32.761C155.333 30.5345 146.206 26.6858 133.306 29.1032Z",
    fill: "url(#paint0_radial_3463_12183)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.871 123.095L122.562 131.365L132.996 118.165H148.805L156.393 107.032H158.922",
    stroke: "black",
    strokeWidth: 4.23008
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 132.518,
    y: 93.9912,
    width: 16.125,
    height: 78.8824,
    rx: 8.06248,
    fill: "url(#paint1_radial_3463_12183)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3463_12183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.937 103.284C101.315 100.09 104.023 97.6841 107.239 97.6841H112.572C115.986 97.6841 118.788 100.386 118.913 103.797L119.547 121.155C119.604 122.708 118.228 123.926 116.693 123.682L98.8594 120.845L100.937 103.284Z",
    fill: "#E2B93B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3463_12183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.91 103.183C157.244 99.9483 159.97 97.4897 163.222 97.4897H168.494C171.796 97.4897 174.546 100.022 174.818 103.312L174.967 105.12C175.092 106.627 173.844 107.891 172.335 107.784L156.55 106.674L156.91 103.183Z",
    fill: "#E2B93B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9347 121.779C95.1188 119.21 97.2561 117.221 99.831 117.221H119.657V128.565H101.252C97.5756 128.565 94.6719 125.445 94.9347 121.779Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.148 108.781C176.148 106.409 174.226 104.487 171.854 104.487H156.546V113.075H171.854C174.226 113.075 176.148 111.152 176.148 108.781Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3463_12183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.645 115.62H156.549C159.03 126.277 159.124 137.35 156.826 148.047L156.549 149.336H148.645V115.62Z",
    fill: "#53CD60"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.942,
    y: 45.6416,
    width: 7.58821,
    height: 38.487,
    fill: "#787878"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3463_12183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.101 87.0563C129.548 88.583 128.41 97.1286 128.41 101.211L130.94 102.006C131.308 99.8854 133.627 95.5172 139.951 95.0083C146.274 94.4993 148.487 99.4613 148.803 102.006C149.805 102.218 151.807 102.356 151.807 101.211C151.807 99.7791 150.542 92.6226 148.803 89.2828C147.065 85.943 139.792 85.1478 134.101 87.0563Z",
    fill: "#53CD60"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2163,
    cy: 239.389,
    rx: 45.1294,
    ry: 3.64682,
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9081 205.211C97.778 179.755 101.709 186.785 110.372 196.592C117.108 204.213 109.16 212.779 99.9047 224.429C90.6494 236.08 80.7972 244.927 74.1707 239.62C67.5443 234.313 55.6192 228.827 75.9081 205.211Z",
    fill: "#53CD60"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.43633,
    ry: 26.9457,
    transform: "matrix(-0.748463 -0.663744 0.659973 -0.750792 83.4057 208.661)",
    fill: "#9DFFA8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2707 220.286L23.5404 207.359C27.0051 203.709 32.2165 202.312 37.0395 203.741L69.3459 213.311C74.3621 214.797 79.7785 213.223 83.2212 209.28L89.3712 202.235",
    stroke: "black",
    strokeWidth: 6.04307,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.215,
    cy: 257.894,
    rx: 62.4517,
    ry: 3.64682,
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.371 240.812C158.2 268.061 152.904 252.862 145.722 245.168C138.54 237.474 150.018 225.556 163.362 212.95C176.706 200.343 190.293 191.278 197.475 198.972C204.657 206.666 218.289 215.533 189.371 240.812Z",
    fill: "#53CD60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.368 240.823C176.024 253.43 162.011 260.226 158.068 256.003C154.126 251.779 161.747 238.136 175.091 225.529C188.436 212.923 203.273 208.256 207.216 212.48C211.158 216.703 202.712 228.217 189.368 240.823Z",
    fill: "#9DFFA8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.051 233.979L253.822 247.588C248.936 251.447 242.313 252.229 236.67 249.614L200.278 232.75C193.676 229.691 185.864 231.319 181.016 236.765L176.371 241.985",
    stroke: "black",
    strokeWidth: 7.47384,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3463_12183",
    x: 98.8594,
    y: 97.6841,
    width: 20.6895,
    height: 26.0291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.89066,
    dy: 4.41153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878268 0 0 0 0 0.504167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3463_12183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3463_12183",
    x: 156.55,
    y: 97.4897,
    width: 18.4258,
    height: 10.3008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.89066,
    dy: 4.41153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.878268 0 0 0 0 0.504167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3463_12183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3463_12183",
    x: 148.645,
    y: 115.62,
    width: 9.83789,
    height: 33.7158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.41153,
    dy: -1.26044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3463_12183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3463_12183",
    x: 128.41,
    y: 86.0388,
    width: 23.3975,
    height: 16.1108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.04175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.752941 0 0 0 0 0.521569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3463_12183"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3463_12183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.184 -9.79365) rotate(94.6555) scale(59.8372 108.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86FFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3463_12183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.145 93.8291) rotate(94.5467) scale(114.091 23.324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfreeBotImg);
export default __webpack_public_path__ + "static/media/sfree-botImg.d652870253f88e4ef8f1e744665275b0.svg";
export { ForwardRef as ReactComponent };